import React, { Component } from 'react';
import { MenuItem, MenuDivider } from 'core/components';
import { TbPlus } from 'react-icons/tb';

class MovePanelButton extends Component {
  render() {
    const { panel, onMovePanel } = this.props;

    // Get all section panels that are not the current panel's section
    const sections = panel.collection
      .get()
      .filter((p) => p.get('type') === 'section' && `${p.id}` !== `${panel.get('parent_panel_id')}`);

    return (
      <MenuItem icon={TbPlus} text="Move Panel to...">
        {panel.get('parent_panel_id') && (
          <>
            <MenuItem text="Out of Section" onClick={() => onMovePanel()} />
            {sections.length > 0 && <MenuDivider />}
          </>
        )}
        {sections.map((p) => (
          <MenuItem key={p.id} text={p.get('title')} onClick={() => onMovePanel(p.id)} />
        ))}
      </MenuItem>
    );
  }
}

export default MovePanelButton;
